import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {Product} from "../../../../store/state/order.state";
import {AdditionalQuestionsChanges, ChangeSet, InitialCertQuestionsChanges} from "../../history/order-history.model";

@Component({
    selector: 'initial-additional-questions-details',
    templateUrl: './initial-additional-questions-details.template.html',
    styleUrls: ['./initial-additional-questions-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InitialAdditionalQuestionsDetailsComponent {

	@Input() product: Product;
	@Input() changeSet: ChangeSet;
	@Input() clientCountry: string;

	isDesiredPreAuditDateChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.initialCertQuestionsChanges().desiredPreAuditDate;
	}

	isDesiredStage1DateChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.initialCertQuestionsChanges().desiredStage1AuditDate;
	}

	isDesiredStage2DateChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.additionalQuestionsChanges().desiredNextAuditDate;
	}

	preAuditRequestChanged() {
		return !!this.changeSet && this.additionalQuestionsChangesPresent()  &&
			!!this.changeSet.changes.productChanges[this.product.standard.name].additionalQuestions.initialCertQuestionsChanges.preAuditRequested;
	}

	preAuditCost(): number {
		let preAuditTotalMandays = this.preAuditMandays;
		return this.product.pricing.pricingAdjustments.dailyRate * preAuditTotalMandays || this.product.pricing.dailyRate * preAuditTotalMandays;
	}

	get preAuditMandays() {
		let preAuditTotalMandays = 1;
		if ("NL" === this.clientCountry) {
			preAuditTotalMandays = 1.25;
		}
		return preAuditTotalMandays;
	}

	get showPricing(): boolean {
		return this.product.pricing.dailyRate !== null && this.product.pricing.dailyRate !== 0;
	}

	private initialCertQuestionsChanges(): InitialCertQuestionsChanges {
		return this.additionalQuestionsChanges().initialCertQuestionsChanges;
	}

	private additionalQuestionsChanges(): AdditionalQuestionsChanges {
		return this.changeSet.changes.productChanges[this.product.standard.name].additionalQuestions;
	}

	private additionalQuestionsChangesPresent() {
		return !!this.changeSet.changes.productChanges[this.product.standard.name] && !!this.changeSet.changes.productChanges[this.product.standard.name].additionalQuestions;
	}
}
